<template>
<div>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="10" md="4">
      <v-card class="elevation-5 pt-5 pb-10 pl-5 pr-5">v3.2.5
        <v-img height="140" contain src="../../assets/Pelican_LogoB.png"></v-img>
        <br />
        <center>
          <b>
            <font face="微軟正黑體" size="5">歡迎使用宅配通訂單系統</font>
          </b>
        </center>
        <br /><br />
        <div v-if="isLogin===true">
          <form>
            <b>
              <font face="微軟正黑體" size="5" color="#1976D2">客戶代號：</font>
            </b>
            <v-text-field type="text" class="font-weight-bold" autofocus outlined clearable maxlength="10" v-model="username" :rules="usernameRules"></v-text-field>
            <b>
              <font face="微軟正黑體" size="5" color="#1976D2">密碼：</font>
            </b>
            <v-text-field :type="showpswd ? 'text':'password'" class="font-weight-bold" outlined v-model="password" :rules="passwordRules" autocomplete="off"></v-text-field>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" x-large @click="btnChkcustData()">
                <font face="微軟正黑體" size="4">確定</font>
              </v-btn>
              <v-btn color="primary" x-large :to="{ name: 'EndPage' }">
                <font face="微軟正黑體" size="4">離開</font>
              </v-btn>
            </v-card-actions>
          </form>
        </div>
        <div v-if="isDsmid===true">
          <b>
            <font face="微軟正黑體" size="5" color="#1976D2">請輸入宅配單號：</font>
            <v-text-field type="text" class="font-weight-bold" autofocus outlined clearable maxlength="12" v-model="dsmid" :rules="dsmidRules"></v-text-field>
          </b>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" x-large @click="btnChkdsmidData()">
              <font face="微軟正黑體" size="4">確定</font>
            </v-btn>
            <v-btn color="primary" x-large :to="{ name: 'EndPage' }">
              <font face="微軟正黑體" size="4">離開</font>
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
      <br />
      <div style="text-align:right">
        <v-btn color="error" @click="btnreload()">
          <font face="微軟正黑體" size="4">重新整理</font>
        </v-btn>
      </div>
    </v-col>
  </v-row>
</div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      usernameRules: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9]*$/).test(v)) {
            this.username = ''
          }
          return true
        },
      ],
      password: '',
      passwordRules: [
        (v) => !!v || " ",
      ],
      showpswd: false,
      dsmid: '',
      dsmidRules: [
        (v) => !!v || " ",
        (v) => {
          if (!RegExp(/^[0-9]*$/).test(v)) {
            this.dsmid = ''
          }
          return true
        },
      ],
      //custfilelstCust: [],
      //custfilelstDSMid: [],
      isLogin: true,
      isDsmid: false,
    };
  },
  /*created() {

  },*/
  methods: {
    btnreload() {
      window.location.reload();
    },
    btnChkcustData() {
      //let Custurl = 'https://queryapi.e-can.com.tw:9091/EDIQRapi/EDIQR_ChkCust/cust_id=' + this.username + '&pass=' + this.password + '&main_id=000000000000001'
      let Custurl = 'https://queryapi2.e-can.com.tw:9091/EDIQRapi/EDIQR_ChkCust/cust_id=' + this.username + '&pass=' + this.password + '&main_id=000000000000001'
      this.$axios.get(Custurl).then(response => {
        this.custfilelstCust = response.data;
        //console.log(response.data);
        if (response.data.cust === '1') {
          this.$cookie.set('accountId', this.username, "0");
          this.$cookie.set('password', this.password, "0");
          this.isLogin = false;
          this.isDsmid = true;
        } else {
          alert('帳號密碼錯誤，請重新輸入');
          this.password = '';
        }
      }).catch(function(error) {
        this.$router.push({
          name: "ErrorPage"
        });
      })
    },
    btnChkdsmidData() {
      if (this.dsmid.length < 12) {
        alert('宅配單號長度錯誤，請重新輸入');
        this.dsmid = '';
      } else {
        if ((this.dsmid.substr(1, 2) !== '01') && (this.dsmid.substr(1, 2) !== '11')) {
          alert('宅配單號錯誤，請重新輸入');
          this.dsmid = '';
        } else {
          if (parseInt(this.dsmid.substr(0, 11)) % 7 !== parseInt(this.dsmid.substr(11, 1))) {
            alert('宅配單號錯誤，請重新輸入');
            this.dsmid = '';
          } else {
            //檢核通過
            //let DSMurl = 'https://queryapi.e-can.com.tw:9091/EDIQRapi/EDIQR_ChkCust/cust_id=' + this.username + '&pass=' + this.password + '&main_id=' + this.dsmid + '001'
            let DSMurl = 'https://queryapi2.e-can.com.tw:9091/EDIQRapi/EDIQR_ChkCust/cust_id=' + this.username + '&pass=' + this.password + '&main_id=' + this.dsmid + '001'
            this.$axios.get(DSMurl).then(response => {
              this.custfilelstDSMid = response.data;
              if (response.data.cust === '1') {
                if (this.custfilelstDSMid.dsm !== '3') {
                  //this.$cookie.set('dsm_type', this.custfilelstDSMid.dsm, "0");
                  this.$cookie.set('custname', this.custfilelstDSMid.cust_name, "0");
                  this.$cookie.set('custphone', this.custfilelstDSMid.cust_cellno, "0");
                  this.$cookie.set('custtel', this.custfilelstDSMid.cust_telno, "0");
                  this.$cookie.set('custzipcode', this.custfilelstDSMid.cust_zipcode, "0");
                  this.$cookie.set('custaddress', this.custfilelstDSMid.cust_address, "0");
                  //console.log('dsm_type:'+this.$cookie.get('dsm_type'));
                  let page_token = 'S';
                  this.$cookie.set('page_token', page_token, "0");
                  this.$cookie.set('dsmid_token', this.dsmid + '001', "0");

                  if (this.custfilelstDSMid.dsm === '0') {
                    this.$router.push({
                      name: "InsDSMdata"
                    });
                  } else if (this.custfilelstDSMid.dsm === '1') {
                    this.$router.push({
                      name: "UpdDSMdata"
                    });
                  } else if (this.custfilelstDSMid.dsm === '2') {
                    this.$router.push({
                      name: "SerchDSM"
                    });
                  } else {
                    this.$router.push({
                      name: "ErrorPage"
                    });
                  }
                } else {
                  alert('此宅配單號已經被使用，請重新輸入');
                  this.dsmid = '';
                }
              } else {
                alert('宅配單號錯誤，請重新輸入');
                this.dsmid = '';
              }
            }).catch(function(error) {
              this.$router.push({
                name: "ErrorPage"
              });
            })
          }
        }
      }


    },
  },
};
</script>
